<template>
    <div>
        <Header label="Support" currentpath="support"></Header>
        <div>
            <!-- Start of waterguru Zendesk Widget script -->

            <!-- End of waterguru Zendesk Widget script -->
        </div>
    </div>
</template>

<script>
import AppStyles from '../style/styles'

import Header from './Header'

export default {
    name: 'Support',
    data () {
        return {
            theme: AppStyles
        }
    },
    components: {
        Header: Header
    }
    // mounted() {
    // /*<![CDATA[*/ window.zE ||
    // (function(e, t, s) {
    //   var n = (window.zE = window.zEmbed = function() {
    //       n._.push(arguments);
    //     }),
    //     a = (n.s = e.createElement(t)),
    //     r = e.getElementsByTagName(t)[0];
    //   (n.set = function(e) {
    //     n.set._.push(e);
    //   }),
    //     (n._ = []),
    //     (n.set._ = []),
    //     (a.async = true),
    //     a.setAttribute("charset", "utf-8"),
    //     (a.src =
    //       "https://static.zdassets.com/ekr/asset_composer.js?key=" + s),
    //     (n.t = +new Date()),
    //     (a.type = "text/javascript"),
    //     r.parentNode.insertBefore(a, r);
    // })(document, "script", "7c321e5f-3a61-46e3-886b-1bf6dfeb010c"); /*]]>*/
    // }
}
</script>
